import { render, staticRenderFns } from "./TableDocuments.vue?vue&type=template&id=438f3da0&"
import script from "./TableDocuments.vue?vue&type=script&lang=js&"
export * from "./TableDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438f3da0')) {
      api.createRecord('438f3da0', component.options)
    } else {
      api.reload('438f3da0', component.options)
    }
    module.hot.accept("./TableDocuments.vue?vue&type=template&id=438f3da0&", function () {
      api.rerender('438f3da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/TableDocuments.vue"
export default component.exports